// extracted by mini-css-extract-plugin
export default {"main_page":"ToyotaYarus_main_page__A1qE0","car_image":"ToyotaYarus_car_image__FliPt"};